import axios from '@/axios';

let isAuthenticated = false;

const checkAuthentication = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    isAuthenticated = false;
    return false;
  }

  try {
    const response = await axios.get( '/check', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    isAuthenticated = response.status === 200;
  } catch (error) {
    isAuthenticated = false;
    localStorage.removeItem("token");
  }

  return isAuthenticated;
};

const getIsAuthenticated = async () => {
  await checkAuthentication();
  return isAuthenticated;
};

const login = (token) => {
  localStorage.setItem("token", token);
  checkAuthentication();
};

const logout = () => {
  localStorage.removeItem("token");
  isAuthenticated = false;
};

export { getIsAuthenticated, checkAuthentication, login, logout };
